export { default as Star } from './Star';
